import { ePermissions } from 'types/administration/userAdministration/ePermissions';
import { IBaseDisbursementType } from '../IBaseDisbursementType';
import { defaultCreate } from '../defaultCreate';
import { ACHStatusPill } from './ACHStatusPill';
import { ACHDisbursementContainer } from './ACHDisbursementContainer';
import { eACHDisbursementCategories } from 'types/order/escrow/eEscrowAchPushDisbursementCategories';
import { eDisbursementType } from 'types/order/escrow/eDisbursementType';
import { eAccountType } from 'types/order/escrow/IAchAccountData';

export interface IACHDisbursementType extends IBaseDisbursementType<eDisbursementType.ACH> { }

export const ACHDisbursementType: IACHDisbursementType = {
  type: eDisbursementType.ACH,

  editPermission: ePermissions.EscrowExpectedAchPushDepositsEdit,
  readPermission: ePermissions.EscrowExpectedAchPushDepositsRead,

  create: (fee, order, isSpruceWithZillowEnabled, isZillowClosing) => {
    const { beneficiary, ...defaultValues } = defaultCreate(fee, order, isSpruceWithZillowEnabled, isZillowClosing);
    const fileNumber = order.transaction.file_number ?? '';

    // If zillow.closing FF is enabled, use the full order number (including state abbreviation)
    // but truncate to 11 characters max due to backend validation
    // Otherwise, truncate the first 6 characters for backward compatibility
    const wellsFargoTransactionNumber = isZillowClosing ? fileNumber.substring(0, 11) : fileNumber.substring(6);

    return {
      type: eDisbursementType.ACH,
      ...defaultValues,
      wellsFargoTransactionNumber,
      ownerId: order.transaction.id!,
      achAccountId: '',
      category: eACHDisbursementCategories.Seller,
      holdback: false,
      holdbackProperties: {},
      account: {
        name: beneficiary ?? '',
        routingNumber: '',
        accountNumber: '',
        accountNumberConfirmation: '',
        accountType: '' as eAccountType,
      },
    };
  },
  container: ACHDisbursementContainer,
  statusPill: ACHStatusPill,
  isReadOnly: (x) => {
    if (x.type === eDisbursementType.ACH) {
      return !!x.disbursedAt || !!x.completedAt || !!x.sentAt;
    }
    return true;
  },
};
